export default {
  fileTypeError: 'File type not supported',
  totalFileSizeError: 'Please upload less than 50MB in total',
  attachmentButtonAriaLabel: 'Add Attachment',
};
